import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class UtilitiesService {

    constructor(
        private http: HttpClient,
    ) {}

    getKeyPassword() {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        }

        return this.http.get<any>(`${environment.apiUrl}/utilities/key_password`, { headers })
    }

    setKeyPassword(password: string, durationMinutes: number) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        }

        const body = {
            password: password,
            duration: durationMinutes
        }

        return this.http.post<any>(`${environment.apiUrl}/utilities/key_password`, body, { headers })
    }

    getMaintenance() {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        }

        return this.http.get<any>(`${environment.apiUrl}/utilities/maintenance`, { headers })
    }

    setMaintenance(start: string, end: string) {
        const jwtToken = (document.cookie.split(';').find(x => x.includes('jwtToken')) || '=').split('=')[1]

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
        }

        const body = {
            start: start,
            end: end
        }

        return this.http.post<any>(`${environment.apiUrl}/utilities/maintenance`, body, { headers })
    }
}